<template>
  <div @click="handleClickInternal()" class="task-component">
    <!-- <h1>{{ msg }}: {{ data.data.time }}</h1> -->
    <h1>{{ index + ' ' + msg }}: {{ data.data.time }}</h1>
  </div>
</template>

<script>
export default {
  name: 'TaskList',
  props: ['data', 'index'],
  data () {
    return {
      msg: 'Task list'
    }
  },
  methods: {
    handleClickInternal () {
      this.msg = 'Clicked task with id ' + this.data.id
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.task-component{
  background-color: green;
}
h1, h2 {
  font-weight: normal;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/TaskList.vue